<template>
  <div>
    <div v-show="!settingCurrentItem">
      <Search
        :title="$lang.report_setting"
        :allowFields="$lang.report_setting_fields"
        :hiddenFields="[]"
        :url="reportSettingUrl"
        :visibleViewCount="false"
        :visibleSettings="false"
        :visibleAdd="false"
        :filterCatch="false"
        :showTotals="true"
        :defaultViewCount="10"
        :dynamicButtons="dynamicButtons"
        primaryKey="id"
        ref="search"
        @getPermisson="updatePermissions"
      />
      <b-row>
        <b-col cols="12" class="text-right pt-3">
          <b-button type="reset" variant="outline-danger" @click="closeModal">
            <mdicon name="close" size="20" />
            {{ $lang.close }}
          </b-button>
        </b-col>
      </b-row>
    </div>
    <b-card v-show="settingCurrentItem">
      <div slot="header">
        <strong v-text="$lang.report_setting" />
      </div>
      <LoadingSpinner
        :loading="settingLoading"
        :loadingText="$lang.sending_data"
      />
      <b-form v-if="!settingLoading">
        <b-form-group
          :label="$lang.report.introduction"
          label-for="introduction"
          :label-cols="this.$config.form.labelCol"
        >
          <requiredComponent
            slot="label"
            :label="$lang.report.settings.introduction"
            :rules="$v.introduction.$params"
          />
          <Editor dir="rtl" v-model="introduction" />
          <b-form-invalid-feedback
            :state="$v.introduction.$dirty ? !$v.introduction.$error : null"
          >
            <div v-if="!$v.introduction.required">
              {{
                $lang.error_required
                  | replace($lang.report.settings.introduction)
              }}
            </div>
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group
          :label="$lang.report.logo"
          label-for="logo"
          :label-cols="this.$config.form.labelCol"
        >
          <requiredComponent
            slot="label"
            :label="$lang.report.settings.logo"
            :rules="$v.logo.$params"
          />
          <selectFind
            :options="logoOptions"
            v-model="$v.logo.$model"
            label="text"
            id="value"
            :isValid="$v.logo.$dirty ? !$v.logo.$error : null"
          />

          <b-form-invalid-feedback id="logo-feedback"
            >{{ $lang.error_required | replace($lang.report.settings.logo) }}
          </b-form-invalid-feedback>
        </b-form-group>
        <b-row>
          <b-col cols="12" class="text-right pt-3">
            <b-button
              type="reset"
              class="mr-2"
              variant="outline-danger"
              @click="closeModal"
            >
              <mdicon name="close" size="20" />
              {{ $lang.cancelButton }}
            </b-button>
            <b-button
              variant="success"
              @click="updateSetting"
              v-if="isAdmin(settingPermissions)"
            >
              <mdicon name="check" size="20" />
              {{ $lang.submitButton }}
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-card>
  </div>
</template>

<script>
import Search from "@/components/base/search";
import LoadingSpinner from "@/components/base/LoadingSpinner";
import Editor from "@/components/ckeditor/editor";
import { required } from "vuelidate/lib/validators";
import { pathOr, includes } from "ramda";
import { generateApiUrl, isAdmin, checkFrontPageName } from "@/shared/utils";

export default {
  name: "report-card",
  components: {
    Search,
    Editor,
    LoadingSpinner,
  },
  props: {
    url: {
      type: String,
      default: null,
    },
    reportIntegratedUrl: {
      type: String,
      default: null,
    },
    resource: {
      type: String,
      default: null,
    },
    code: {
      type: [String, Number],
      default: null,
    },
  },
  validations: {
    introduction: { required },
    logo: {},
  },
  data() {
    return {
      id: this.$route.params.id,
      isLoading: false,
      itemGroups: [],
      logo: null,
      introduction: null,
      logoOptions: [
        {
          text: "رسا",
          value: "rasa",
        },
        {
          text: this.$lang.company,
          value: "company",
        },
      ],
      displayNameOptions: [
        {
          text: "نام کامل",
          value: "full_name",
        },
        {
          text: "کد",
          value: "internal_code",
        },
      ],
      settingList: [],
      settingCurrentItem: null,
      settingLoading: false,
      dynamicButtons: [
        {
          id: "0",
          name: "edit",
          click: this.showForm,
        },
      ],
      settingPermissions: [],
      confirmModal: false,
      settingModal: false,
      report_settings: null,
      reportsPermissions: [],
      otherData: null,
      reportItems: [],
    };
  },
  computed: {
    reportSettingUrl() {
      return generateApiUrl(["resources", "report_settings"], [], {
        resource: "center_execute",
      });
    },
  },
  methods: {
    pathOr,
    includes,
    generateApiUrl,
    isAdmin,
    checkFrontPageName,
    showForm(item) {
      this.settingCurrentItem = item;
      this.logo = this.logoOptions.find(
        (x) => x.value === pathOr(null, ["setting", "logo"], item)
      );
      this.introduction = pathOr(null, ["setting", "introduction"], item);
    },
    updatePermissions(data) {
      this.settingPermissions = data;
    },
    updateReportsPermissions(data) {
      this.reportsPermissions = data;
    },
    async updateSetting() {
      this.$v.$touch();
      if (this.$v.$anyError) return;

      try {
        this.settingLoading = true;
        const id = pathOr(null, ["id"], this.settingCurrentItem);
        const url = generateApiUrl(["resources", "report_settings_id"], [id]);
        const payload = {
          settings: {
            introduction: this.introduction,
            logo: pathOr(null, ["value"], this.logo),
          },
        };
        const response = await this.$httpService.put(url, payload);
        this.$notify.success(response.data.message);
        this.showForm(null);
        this.settingModal = false;
        this.getReports();
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.settingLoading = false;
      }
    },
    closeModal() {
      this.$emit("closeModal");
    },
  },
};
</script>
